<template lang="pug">
//- .parent(v-bind:class="{ 'active': showSpinner}")
.spinner(v-bind:class="{ 'active': showSpinner}")
   //- .dot1
   //- .dot2
</template>

<script>
export default {
  props: {
    showSpinner: {
      data: Boolean,
      default: false
    }
  }
}
</script>

<style>
/* .spinner {
   margin: 100px auto;
     width: 40px;
     height: 40px;
     position: relative;
     text-align: center;
     -webkit-animation: sk-rotate 2s infinite linear;
     animation: sk-rotate 2s infinite linear;
     top: 30%;
     position: absolute;
     left: 48%;
     display: none;
} */

/* .parent {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
   z-index: 9999;
    background-color: rgba(255,255,255,.5);
    display: none;

}

.dot1, .dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #fff;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}
@keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
} */

.spinner {
  width: 40px;
  height: 40px;
  margin: 100px auto;
  background-color: #ccc;
  top: 30%;
  position: absolute;
  left: 47%;
  display: none;
  border-radius: 100%;
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

.active {
   display: inline;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Spinner.vue